<template>
    <app-layout>
      <Head title="Lists"/>
        <template #header>
            <div class="flex justify-between">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Lists
                </h2>
                <jet-button @click="handleButtonClick(null, 'create')">Create List</jet-button>
            </div>
        </template>

        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8 overflow-hidden relative">
                    <general-table
                        :columns="columns"
                        :url="route('groups.table')"
                        :clickable-row="{route: 'groups.view', id: 'tra_id'}"
                    />

                    <group-create-modal
                        v-if="showCreateModal"
                        :is-open="showCreateModal"
                        @close="showCreateModal = false"
                        @group-created="handleGroupCreate"
                    />
                </div>
            </div>
        </div>

        <jet-dialog-modal v-if="showEditModal" :show="showEditModal" @close="showEditModal = false">
            <template #title> Edit {{ groupEditDetails.title }} </template>

            <template #content>
                <div>
                    <label for="ged_title">Title</label>
                    <jet-input
                        v-model="groupEditDetails.title"
                        name="ged_title"
                        placeholder="List Name"
                        class="mb-3 w-full"
                    />
                </div>
                <div>
                    <label for="ged_description">Description</label>
                    <textarea
                        v-model="groupEditDetails.description"
                        name="ged_description"
                        placeholder="List Description"
                        class="mb-3 w-full"
                    />
                </div>
            </template>

            <template #footer>
                <button class="mr-2" @click="showEditModal = false">
                    Cancel
                </button>
                <jet-secondary-button
                    @click.native="updateGroup(groupEditDetails)"
                >
                    Update List
                </jet-secondary-button>
            </template>
        </jet-dialog-modal>

        <jet-dialog-modal
            v-if="showDeletionModal"
            :show="showDeletionModal"
            @close="showDeletionModal = false"
        >
            <template #title>
                Delete List
            </template>

            <template #content>
                Are you sure you want to delete this list?
            </template>

            <template #footer>
                <button @click="modalClose">
                    Cancel
                </button>
                <jet-danger-button
                    class="ml-2"
                    @click="deleteGroup(groupSetForDeletion)"
                >
                    Delete List
                </jet-danger-button>
            </template>
        </jet-dialog-modal>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import ListTableActionButtons from "../../components/ListTableActionButtons";
import GroupTableTitle from "../../components/GroupTableTitle";
import GroupTableLastMessage from "../../components/GroupTableLastMessage";
import JetDropdown from "../../Jetstream/Dropdown";
import JetDropdownLink from "../../Jetstream/DropdownLink";
import JetDialogModal from "../../Jetstream/DialogModal";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetNavLink from "../../Jetstream/NavLink";
import JetButton from "../../Jetstream/Button";
import JetDangerButton from "../../Jetstream/DangerButton";
import GeneralTable from "@/components/GeneralTable/GeneralTable";
import GroupCreateModal from "@/components/GroupCreateModal.vue";
import { markRaw } from "vue";
import { useGeneralTableStore } from "@/Stores/general_table";
import {mapWritableState, mapActions} from 'pinia';

export default {
    mounted() {},
    components: {
        AppLayout,
        GeneralTable,
        GroupTableTitle,
        GroupTableLastMessage,
        GroupCreateModal,
        JetDropdown,
        JetDropdownLink,
        JetDialogModal,
        JetNavLink,
        JetButton,
        JetSecondaryButton,
        JetDangerButton,
       
    },
    props: {
    },
    data() {
        return {
            columns: [
                {
                    label: "Title",
                    name: "title",
                    sortable: true,
                    component: markRaw(GroupTableTitle)
                },
                {
                    label: "Owner",
                    name: "owner.name",
                    sortable: false
                },
                {
                    label: "Contacts",
                    name: "contacts_count",
                    sortable: false
                },
                {
                    label: "",
                    name: "View",
                    sortable: false,
                    event: "click",
                    width: "150px",
                    component: markRaw(ListTableActionButtons)
                }
            ],
            groupEditDetails: {
                traId: null,
                title: null,
                description: null
            },
            groupSetForDeletion: null,
            showCreateModal: false,
            showDeletionModal: false,
            showEditModal: false
        };
    },
    computed: {},
    methods: {
        ...mapActions(useGeneralTableStore, ['clearData', 'fetchData']),
        placeholder() {
        },
        handleButtonClick(data, type) {
            console.log('button clicked', data, type);
            if (type === "delete") {
                this.toggleDeletionModal(data);
            }

            if (type === "view") {
              this.$inertia.visit(route('groups.view', data.tra_id), { method: 'get' });
            }

            if (type == 'create') {
                this.showCreateModal = true;
            }
        },
        handleGroupCreate() {
            this.showCreateModal = false;
            this.fetchData();
        },
        toggleDeletionModal(row) {
            if (!this.showDeletionModal) {
                this.groupSetForDeletion = row.tra_id;
            }
            this.showDeletionModal = !this.showDeletionModal;
        },
        toggleEditModal(row) {
            if (!this.showEditModal) {
                this.groupEditDetails.traId = row.tra_id;
                this.groupEditDetails.title = row.title;
                this.groupEditDetails.description = row.description;
            }
            this.showEditModal = !this.showEditModal;
        },
        modalClose(){
          this.showDeletionModal = false;
          document.body.style.overflow = null
        },
        deleteGroup(groupSetForDeletion) {
            this.$inertia.post(
                route("groups.delete", {
                    traId: groupSetForDeletion
                }),
                {},
                {
                    onSuccess: () => {
                        this.$toasted.show(`List has been deleted.`, {
                            position: "bottom-right",
                            type: "success",
                            duration: 3000
                        });
                        // Reload the datatable
                        this.showDeletionModal = false;
                        this.fetchData();
                    },
                    onError: errors => {
                      this.$toasted.show(errors.message, {
                        position: "bottom-right",
                        duration: 3000,
                        type: "error"
                      });
                      this.showDeletionModal = false;
                      this.fetchData();
                    }
                }
            );
            document.body.style.overflow = null
        },
        updateGroup() {
            this.$inertia.post(
                route(
                    "groups.edit.submit.json",
                    this.groupEditDetails.traId
                ),
                {
                    title: this.groupEditDetails.title,
                    description: this.groupEditDetails.description
                },
                {
                    onSuccess: page => {
                        // Reload the datatable
                        this.showEditModal = false;
                        this.resetGroupEditDetails();
                    },
                    onError: errors => {
                        this.$toasted.show(errors.contact_id, {
                            position: "bottom-right",
                            type: "error",
                            duration: 1000
                        });
                    }
                }
            );
        },
        resetGroupEditDetails() {
            this.groupEditDetails.traId = null;
            this.groupEditDetails.title = null;
            this.groupEditDetails.description = null;
        }
    }
};
</script>
